import { render } from "./CommandCenterChannelMix.vue?vue&type=template&id=79bb4aac&scoped=true"
import script from "./CommandCenterChannelMix.vue?vue&type=script&lang=js"
export * from "./CommandCenterChannelMix.vue?vue&type=script&lang=js"

import "./CommandCenterChannelMix.vue?vue&type=style&index=0&id=79bb4aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bb4aac"]])

export default __exports__